import { render, staticRenderFns } from "./RegistrationTermsModal.vue?vue&type=template&id=63436d50&scoped=true"
import script from "./RegistrationTermsModal.vue?vue&type=script&lang=js"
export * from "./RegistrationTermsModal.vue?vue&type=script&lang=js"
import style0 from "./BasicModal.scss?vue&type=style&index=0&id=63436d50&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63436d50",
  null
  
)

export default component.exports